function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15.38 1.86 459.86 466.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.12,199s5.76-45.16-62.86-125S313,2.29,271.05,19.46,200.77,112.4,163.84,124.65,30.91,142.52,16.64,232.88,111.26,422,232.58,452.7,455.2,309.2,465.87,269,475.12,199,475.12,199Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.12,199s5.76-45.16-62.86-125S313,2.29,271.05,19.46,200.77,112.4,163.84,124.65,30.91,142.52,16.64,232.88,111.26,422,232.58,452.7,455.2,309.2,465.87,269,475.12,199,475.12,199Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.12,83.15S360.73,83,392,3.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.57,92.62s6.55-1.06,10.34,1c16.08,8.77,56.73,31.16,86.56-1.6A65.77,65.77,0,0,0,380,54.1c1.55-15.83,3.71-41.7,1.93-47.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,104s95.69,16.67,93.09-99.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.78,
    y: 80.95,
    width: 4.87,
    height: 5.79,
    transform: "translate(-8.97 36.3) rotate(-7.82)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 81.63,
    width: 3.04,
    height: 3.04,
    transform: "translate(-8.85 36.83) rotate(-7.82)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.78,
    y: 90.69,
    width: 4.87,
    height: 5.79,
    transform: "translate(-10.3 36.39) rotate(-7.82)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 91.37,
    width: 3.04,
    height: 3.04,
    transform: "translate(-10.17 36.91) rotate(-7.81)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 102.42,
    width: 4.87,
    height: 5.79,
    transform: "translate(-11.92 36.19) rotate(-7.82)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.32,
    y: 103.1,
    width: 3.04,
    height: 3.04,
    transform: "translate(-11.78 36.71) rotate(-7.81)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4,129.05s-9.19,2.57-9.62,2.72-.88,1.45-.15,2.61,2.18,6.83,2.18,6.83a19.08,19.08,0,0,0,4.79,2.47c1.89.43,6.24.87,7.12-1.6s.72-9-.88-10.75S177.61,128.21,176.4,129.05Z",
    style: {
      fill: "#bababa",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.94,131.91a23.66,23.66,0,0,1,4.79,2.91c1.6,1.45,1.89,1.74,2,2.47a31.17,31.17,0,0,1,.58,6.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.76,137.29s5.08-2.47,5.08-6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,188.25s-5.66-4.93-12.2-11.61S193.35,160.08,192,156s-4.65-16.7-6.24-21.06-1.89-7.4-3.2-9-7.55-3.92-8.13-4.21-3.63-1.31-6.39-2.47-6.53,0-3.05,3.63a14.49,14.49,0,0,0,8.72,3.92l4.35,3.63s1.6,7.55,1.31,9.44a5.17,5.17,0,0,1-1.16,2.76,6.49,6.49,0,0,1-4.5-.73c-2.33-1.3-3.93-3.19-8.43-2s-3.19,4.65-.43,5.08,7.4,1.6,9.44,4.07.58,5.23,4.79,8.13,5.23,3.63,5.23,3.63A111.86,111.86,0,0,1,188.41,180c1.16,10.16,2.62,21.05,12.49,29.91s14.37,11.76,16.26,11.47,3.34-1,3.34-4.64S218.76,188.25,218.76,188.25Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,168.47s7,24.15,16.71,36.3c6.32,7.9,10.78,9.57,10.78,9.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,162.68c.41,1.42,1,3.58,1.59,6.2a16.65,16.65,0,0,0,9.67-5.27,51.44,51.44,0,0,1-3.46-6C189.36,161.07,186.63,162.27,184.9,162.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.42,126.65a6.93,6.93,0,0,1,3-4.5c-.49-.2-.84-.34-1-.4-.28-.14-1.12-.44-2.21-.85a9.39,9.39,0,0,0-2.75,4.92A16.79,16.79,0,0,0,172.42,126.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.26,142.17c.4,1,.81,3.06-1.68,5.39a7.53,7.53,0,0,1,1.75,1.49,4.47,4.47,0,0,1,.41.59,7.87,7.87,0,0,0,2.76-6.87A6.69,6.69,0,0,1,174.26,142.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6,126a7,7,0,0,0-1.9-1.38,10,10,0,0,0-4.3,4.47l1.7,1.41.27,1.32.17.05c.05-.19,1-4,4.61-5A4.33,4.33,0,0,0,182.6,126Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.34,
    cy: 446.74,
    r: 8.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.82,433.4s-8,11.91-12.73,15.6-14.57,8.62-18.27,9.86-3.69,3.49-3.69,4.72.2,3.49,1.84,3.69,56.45,0,56.45,0,4.31-1.23,4.31-4.51a10.34,10.34,0,0,0-.82-4.73l-.2-19.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.09,
    y1: 448.59,
    x2: 245.16,
    y2: 448.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.34,
    y1: 455.57,
    x2: 236.34,
    y2: 460.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,467.36h5.08a56.87,56.87,0,0,0-7.37-18.84l-.6.49a39.61,39.61,0,0,1-3.5,2.41A52.84,52.84,0,0,1,214,467.36Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,462.76a17.21,17.21,0,0,0-.12-2.06H189.92a4.42,4.42,0,0,0-.79,2.88c0,1.23.2,3.49,1.84,3.69s56.45,0,56.45,0S251.73,466,251.73,462.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.36,439s-4.45,6.36-9.18,10.05-14.57,8.62-18.26,9.86-3.7,3.49-3.7,4.72.21,3.49,1.85,3.69,56.45,0,56.45,0,4.31-1.23,4.31-4.51A10.34,10.34,0,0,0,278,458l-1.65-15.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.43,
    cy: 446.74,
    r: 8.83,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.18,
    y1: 448.59,
    x2: 272.26,
    y2: 448.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.43,
    y1: 455.57,
    x2: 263.43,
    y2: 460.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.08,467.36h5.08a57.31,57.31,0,0,0-7.37-18.84l-.61.49a39.35,39.35,0,0,1-3.49,2.41A53.1,53.1,0,0,1,241.08,467.36Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.83,462.76a15.19,15.19,0,0,0-.13-2.06H217a4.44,4.44,0,0,0-.8,2.88c0,1.23.21,3.49,1.85,3.69s56.45,0,56.45,0S278.83,466,278.83,462.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.72,234.14v9.11s-.87,16.06-1.52,23.87.87,17.57.87,17.57-3.69,47.95.22,63.79,5.85,62,5.85,62l.87,10s0,3.9-1.08,3.9-1.74.22-2,3,.66,6.51,1.74,7.16S245,441.12,245,441.12s-.43-2,2.39-2.17,29.07,5.64,29.07,5.64a9.47,9.47,0,0,0,2.17-5c.22-2.82-3.47-8.46-3.47-8.46l-.43-18.66s.86-29.07-2.17-43.61-3.26-30.37-2.61-46.43,3.91-35.8,5.43-39.05,4.12-19.31,3.25-29.51-1.74-14.53-1.74-14.53,0-.91,0-2.08S218.72,234.14,218.72,234.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.73,234.8c-10-.39-18-.66-18-.66v8.69l18,.17Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46,243.23l16,.15c-.37-2.76-.63-4-.63-4s0-.91,0-2.08c0-.4-6.63-.88-15.4-1.35Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.85,243l17.79.16v-7.43c-5.64-.28-11.91-.56-17.79-.8Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.89,
    y: 236.74,
    width: 9.11,
    height: 5.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "247.7 420.68 248.88 427.67 242.59 428.1 246.06 435.69",
    style: {
      fill: "none",
      stroke: "#a6a6a6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.65,314.45c1,17.48,2.45,39.79,3.61,44.66,2,8.24,13,53.15,13,53.15",
    style: {
      fill: "none",
      stroke: "#a6a6a6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8,279.92l3.68,12.58s.33,6.82.85,16.13",
    style: {
      fill: "none",
      stroke: "#a6a6a6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,141.75s-14.74,22.6-14.54,29.87.2,18.28.2,18.28.78,34.79.19,37.34-1.57,7.08-.78,7.47,13.56,1.18,16.31,1.57,41.27,1.58,45,1,4.32-5.7,4.32-7.08,6.48-65.84,6.48-82.35-2.75-19.26-7.07-22.21-14.54-7.07-14.54-7.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28,142.08S258,152.82,257.53,164.73,260.29,205,260.29,205s14.52-4.35,20-3.34a45.19,45.19,0,0,1,11,3.92s2.62-12.05.73-31.94-1-32.53-2.61-36.88-5.09-10.9-11.33-10",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.31 132.7 228.9 137.03 236.37 142.34 237.6 139.5 235.31 132.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.9 137.03 226.54 148.24 234.21 141.16 228.9 137.03",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.3,138.61s-5.9,1.57-7.67,3.73-3.34,4.72-3.14,7.47.2,3.93.39,5.3-8.06,22.8-8.84,37.15-2.95,33-2.95,33l3.15,7.86L229.88,221s-3.93-26.13-.78-44.41,4.71-21.43,4.71-21.43a14.26,14.26,0,0,0,4.52-5.3,50.8,50.8,0,0,1,4.92-7.47Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.36,79.69s-2.74.15-4.57-4-.3-5.48.77-4.72,1.82,1.37,1.82,1.37-2-5.78,2.44-9,4,1.22,4,1.22-.46-1.37,5.63-4.72,9.13-3.81,16.14-2.59,8.37,4,8.37,4-7-1.67-10.66,3.2-4.72,8.37-6.54,11A16.16,16.16,0,0,1,221,81.82C216.93,83,212.36,79.69,212.36,79.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.36,79.69s.91,18.58,2.74,23.14a32.34,32.34,0,0,0,5.48,8.53s2.9,10.35,5.33,11.72,6.4.15,6.4.15,4.87,16.29,5.78,16.45,23.9-23.3,23.9-23.3-3.65-9.74-3.65-10.2,2.43-17.05,1.67-23.6-3.35-16.29-9-20.24-12.18-2.74-17.35.76-7.92,14.46-7.92,14.46L220,81.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,82.58c-.76-6.54-3.35-16.29-9-20.24s-12.18-2.74-17.35.76-7.92,14.46-7.92,14.46,2.13-3.5,11.72-4.11c0,0,2.44,19.49,2.74,23.75s-4,6.7-4,8.83,2.14,10.2,2.29,11.57-6.24,5.63-6.24,5.63,4.37,16.12,5.29,16.27S262,116.38,262,116.38s-3.65-9.74-3.65-10.2S260.77,89.13,260,82.58Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,62.34c-5.63-4-12.18-2.74-17.35.76s-7.92,14.46-7.92,14.46,8.07-6.7,20.4-2.89c9.13,2.82,12.42,4.72,13.51,5.51C258.61,73.85,256,65.83,251,62.34Z",
    style: {
      fill: "#bababa",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.31,123.23s15.83-10.65,16.44-13.85.91-11.57.91-11.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.39,
    y1: 113.65,
    x2: 235.8,
    y2: 134.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.88,
    y1: 128.97,
    x2: 259.15,
    y2: 108.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.2 108.16 258.34 106.18 258.64 104.05 249.51 104.05 249.2 108.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.36,90.27c0,4.16-2.79,7.54-6.24,7.54s-6.24-3.38-6.24-7.54,2.79-7.53,6.24-7.53S256.36,86.11,256.36,90.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.65,90.27c0,2.29-1.47,4.14-3.29,4.14s-3.29-1.85-3.29-4.14,1.47-4.14,3.29-4.14S252.65,88,252.65,90.27Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.12,85.16a5.15,5.15,0,0,1,3.34,5.11c0,2.61-1.57,4.77-3.63,5.18",
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,104.81l-5.33,1.68-.61-13.55-2.13-3.35s-3.65,0-4.72,1.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,112.12s4.27-.31,6.4-2.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.2,92.85c.23,1.24-.15,2.35-.85,2.48s-1.46-.76-1.7-2,.15-2.35.85-2.48S233,91.61,233.2,92.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,96c.23,1.24-.15,2.36-.85,2.49s-1.46-.76-1.7-2,.15-2.35.85-2.49S219.79,94.81,220,96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3,88.67s6.24-3,11.12-1.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.06 109.52 240.3 137.23 246 145.88 269.58 116.79 265.06 109.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.31,206.12s-2.18,7.26,0,13.5,10.45,9.15,19.31,6.1,9.15-9.44,9.44-13.36,1.31-3,.87-4.71S273.94,198.13,261.31,206.12Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.54,189.13s-4.23,9.61-4.85,10.23-4.67.88-5.47,1.5a6.63,6.63,0,0,1-2.82,1.41,13.29,13.29,0,0,1-7.41.35c-3.52-1-2,5.38,3.53,6.26s6-.09,9.7-1.06,6.44.89,8.29,1.5,4.23-.35,6.17-.44A16.11,16.11,0,0,1,287,210c2.55.88,3.79,1,4.93-.27a6,6,0,0,0,1.59-5.29c-.35-2.47-4.32-5.91-8.2-8.2s-9.52-5.11-9.52-5.11Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.22,200.86a8.37,8.37,0,0,1,2.21,7l1.85-.26s.79-5.91-1.76-7.23C265.52,200.33,263.84,200.15,263.22,200.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.47,204.47c-.35-2.47-4.32-5.91-8.2-8.2s-9.52-5.11-9.52-5.11l-2.21-2s-2.39,5.43-3.84,8.39c.74,1.23,2.55,3.67,5.43,4.13,3.88.62,4.76-1.23,7.23,1.15s6.7,5.46,9.88,5.73l.55,0A6.06,6.06,0,0,0,293.47,204.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.34,189.25a3.08,3.08,0,0,0-2.38-2.83,2.57,2.57,0,0,0-2.66,1.12c-2.16,2.76-1.38,6.88-1,8.65s1.37,4.72,3.54,4.13,2.75-1.57,2.75-5.11C279.61,193,279.46,190.72,279.34,189.25Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,192.25a3.09,3.09,0,0,0-2.38-2.83,2.57,2.57,0,0,0-2.66,1.12c-2.16,2.75-1.38,6.88-1,8.65s1.37,4.72,3.53,4.13,2.75-1.58,2.75-5.11C287,196,286.87,193.72,286.75,192.25Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,199.27s2.91-.44,3,2.12.7,8.73-1.24,9.08-2.38-.62-2.38-1.94a22.68,22.68,0,0,0-.18-2.65l-.08-6.43Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07,198.13a2.66,2.66,0,0,0-2-2.43,2.21,2.21,0,0,0-2.29,1c-1.86,2.37-1.19,5.92-.85,7.44s1.18,4.06,3,3.55,2.37-1.35,2.37-4.4C293.3,201.39,293.17,199.4,293.07,198.13Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-3--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.16,
    y: 372.3,
    width: 87.06,
    height: 65.61,
    rx: 2.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.2,
    y1: 431.78,
    x2: 398.94,
    y2: 431.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.2,
    y1: 431.78,
    x2: 317.2,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.65,
    y1: 431.78,
    x2: 322.65,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.1,
    y1: 431.78,
    x2: 328.1,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.55,
    y1: 431.78,
    x2: 333.55,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339,
    y1: 431.78,
    x2: 339,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.45,
    y1: 431.78,
    x2: 344.45,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.9,
    y1: 431.78,
    x2: 349.9,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.35,
    y1: 431.78,
    x2: 355.35,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.8,
    y1: 431.78,
    x2: 360.8,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.24,
    y1: 431.78,
    x2: 366.24,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.69,
    y1: 431.78,
    x2: 371.69,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.14,
    y1: 431.78,
    x2: 377.14,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.59,
    y1: 431.78,
    x2: 382.59,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.04,
    y1: 431.78,
    x2: 388.04,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.49,
    y1: 431.78,
    x2: 393.49,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.94,
    y1: 431.78,
    x2: 398.94,
    y2: 432.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.93,430.79h76.28V420.25l-5.39-10.44a.62.62,0,0,1-.07-.23L386,378.63a.58.58,0,0,0-1.16,0l-4.88,37.78a.74.74,0,0,1-.26.47l-4.7,3.64a.54.54,0,0,1-.84-.23l-4.74-9.78a.54.54,0,0,0-.95-.12l-4.9,6.32-5.45,7-5.45-7-4.8-6.19a.56.56,0,0,0-1,.22l-5.11,15.81-5.45-28.19-5.44,31-5.45-4.22-4.32-12.25c-.24-.69-1.13-.49-1.13.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.21,430.81H319.93v-9.07l5.39-9a.84.84,0,0,0,.08-.2L330.19,386a.59.59,0,0,1,1.16,0l4.89,32.49a.54.54,0,0,0,.25.4L341.2,422a.59.59,0,0,0,.83-.21l4.74-8.4a.59.59,0,0,1,1-.11l4.9,5.44,5.45,6,5.45-6,4.8-5.33a.6.6,0,0,1,1,.19l5.11,13.6h5.45l5.45,2.42,5.44-3.63,4.32-10.53a.59.59,0,0,1,1.13.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.24,
    y1: 381.06,
    x2: 378.12,
    y2: 381.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.24,
    y1: 385.01,
    x2: 378.12,
    y2: 385.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.24,
    y1: 388.96,
    x2: 378.12,
    y2: 388.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.24,
    y1: 392.91,
    x2: 378.12,
    y2: 392.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.24,
    y1: 396.87,
    x2: 378.12,
    y2: 396.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.24,
    y1: 400.82,
    x2: 378.12,
    y2: 400.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.4,
    y1: 381.06,
    x2: 359.51,
    y2: 381.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.4,
    y1: 385.01,
    x2: 359.51,
    y2: 385.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.4,
    y1: 388.96,
    x2: 359.51,
    y2: 388.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.4,
    y1: 392.91,
    x2: 359.51,
    y2: 392.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.4,
    y1: 396.87,
    x2: 359.51,
    y2: 396.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.4,
    y1: 400.82,
    x2: 359.51,
    y2: 400.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphic--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "340.8 311.13 322.91 311.13 313.97 326.63 322.91 342.12 340.8 342.12 349.75 326.63 340.8 311.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.74 279.98 322.85 279.98 313.9 295.47 322.85 310.96 340.74 310.96 349.68 295.47 340.74 279.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.22 279.98 376.33 279.98 367.39 295.47 376.33 310.96 394.22 310.96 403.17 295.47 394.22 279.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.71 326.38 349.82 326.38 340.88 341.88 349.82 357.37 367.71 357.37 376.66 341.88 367.71 326.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.64 295.64 349.75 295.64 340.8 311.13 349.75 326.63 367.64 326.63 376.58 311.13 367.64 295.64",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.89 264.44 349 264.44 340.06 279.93 349 295.43 366.89 295.43 375.84 279.93 366.89 264.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.55 310.89 376.66 310.89 367.71 326.38 376.66 341.88 394.55 341.88 403.49 326.38 394.55 310.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Data--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.63,303.51h-4.2a1,1,0,1,1,0-2.07h4.2a1,1,0,0,1,0,2.07Zm1,3.76a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,307.27Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,312.07Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.08h4.2A1,1,0,0,0,71.66,316.87Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,321.67Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,326.47Zm0,4.79a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,331.26Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,336.06Zm15.71-33.58a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,302.48Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,307.27Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,312.07Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.08h11A1,1,0,0,0,87.37,316.87Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,321.67Zm13.19,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,326.47Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,331.26Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,336.06Zm-8.34-33.58a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,92.22,302.48Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,95.82,302.48Zm3.59,0a1.2,1.2,0,1,0-1.2,1.2A1.19,1.19,0,0,0,99.41,302.48Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,0,0,2.4,0Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,106.61,302.48Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,110.21,302.48Zm-18,9.59a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,92.22,312.07Zm3.6,0a1.2,1.2,0,1,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm3.59,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,99.41,312.07Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,103,312.07Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,106.61,312.07Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,110.21,312.07Zm-5.7,13.8a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,104.51,325.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,108.11,325.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,111.71,325.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,115.31,325.87Zm3.59,0a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,118.9,325.87Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,0,0,2.4,0Zm-18,9.89a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,104.51,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,108.11,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,111.71,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,115.31,335.76Zm3.59,0a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,118.9,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,122.5,335.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63,341.91h-4.2a1,1,0,1,1,0-2.08h4.2a1,1,0,0,1,0,2.08Zm1,3.76a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,345.67Zm0,4.79a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,350.46Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,355.26Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.08h4.2A1,1,0,0,0,71.66,360.06Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,364.86Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,369.66Zm0,4.79a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,374.45Zm15.71-33.58a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.08h11A1,1,0,0,0,87.37,340.87Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,345.67Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,350.46Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,355.26Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.08h11A1,1,0,0,0,87.37,360.06Zm13.19,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,364.86Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,369.66Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,374.45Zm-8.34-33.58a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,92.22,340.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,95.82,340.87Zm3.59,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,99.41,340.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,103,340.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,106.61,340.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,110.21,340.87Zm-18,9.6a1.2,1.2,0,1,0-1.2,1.19A1.2,1.2,0,0,0,92.22,350.47Zm3.6,0a1.2,1.2,0,1,0-1.2,1.19A1.2,1.2,0,0,0,95.82,350.47Zm3.59,0a1.2,1.2,0,1,0-1.2,1.19A1.19,1.19,0,0,0,99.41,350.47Zm3.6,0a1.2,1.2,0,1,0-1.2,1.19A1.19,1.19,0,0,0,103,350.47Zm3.6,0a1.2,1.2,0,1,0-1.2,1.19A1.2,1.2,0,0,0,106.61,350.47Zm3.6,0a1.2,1.2,0,1,0-1.2,1.19A1.2,1.2,0,0,0,110.21,350.47Zm-5.7,13.79a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,104.51,364.26Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,108.11,364.26Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,111.71,364.26Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,115.31,364.26Zm3.59,0a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,118.9,364.26Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,122.5,364.26Zm-18,9.89a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,104.51,374.15Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,108.11,374.15Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,111.71,374.15Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,0,0,2.4,0Zm3.59,0a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,118.9,374.15Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,122.5,374.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63,381.22h-4.2a1,1,0,1,1,0-2.07h4.2a1,1,0,0,1,0,2.07Zm1,3.77a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,385Zm0,4.79a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,389.78Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,394.58Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.08h4.2A1,1,0,0,0,71.66,399.38Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,404.18Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,409Zm0,4.79a1,1,0,0,0-1-1h-4.2a1,1,0,1,0,0,2.07h4.2A1,1,0,0,0,71.66,413.77Zm15.71-33.58a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,380.19Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,385Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,389.78Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.07h11A1,1,0,0,0,87.37,394.58Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,0,0,0,2.08h11A1,1,0,0,0,87.37,399.38Zm13.19,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,404.18Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,409Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,100.56,413.77Zm-8.34-33.58a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,92.22,380.19Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,95.82,380.19Zm3.59,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,99.41,380.19Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,103,380.19Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,106.61,380.19Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,110.21,380.19Zm-18,9.59A1.2,1.2,0,1,0,91,391,1.19,1.19,0,0,0,92.22,389.78Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.19,1.19,0,0,0,95.82,389.78Zm3.59,0a1.2,1.2,0,1,0-1.2,1.2A1.19,1.19,0,0,0,99.41,389.78Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.19,1.19,0,0,0,103,389.78Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.19,1.19,0,0,0,106.61,389.78Zm3.6,0A1.2,1.2,0,1,0,109,391,1.19,1.19,0,0,0,110.21,389.78Zm-5.7,13.8a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,104.51,403.58Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,108.11,403.58Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,111.71,403.58Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,115.31,403.58Zm3.59,0a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,118.9,403.58Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,122.5,403.58Zm-18,9.89a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,104.51,413.47Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,108.11,413.47Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,111.71,413.47Zm3.6,0a1.2,1.2,0,1,0-2.4,0,1.2,1.2,0,0,0,2.4,0Zm3.59,0a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,118.9,413.47Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,122.5,413.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.08,303.51h-4.2a1,1,0,0,1,0-2.07h4.2a1,1,0,1,1,0,2.07Zm1,3.76a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,307.27Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,312.07Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.08h4.2A1,1,0,0,0,136.12,316.87Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,321.67Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,326.47Zm0,4.79a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,331.26Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,336.06Zm15.7-33.58a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,302.48Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,307.27Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,312.07Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.08h11A1,1,0,0,0,151.82,316.87Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,321.67Zm13.19,4.8a1,1,0,0,0-1-1H153a1,1,0,1,0,0,2.07h11A1,1,0,0,0,165,326.47Zm0,4.79a1,1,0,0,0-1-1H153a1,1,0,1,0,0,2.07h11A1,1,0,0,0,165,331.26Zm0,4.8a1,1,0,0,0-1-1H153a1,1,0,1,0,0,2.07h11A1,1,0,0,0,165,336.06Zm-8.34-33.58a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,156.67,302.48Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,160.27,302.48Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,163.87,302.48Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,167.47,302.48Zm3.59,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm-18,9.59a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,156.67,312.07Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,160.27,312.07Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,163.87,312.07Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm3.59,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,171.06,312.07Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,174.66,312.07Zm-5.7,13.8a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,169,325.87Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,176.16,325.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,179.76,325.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,183.36,325.87Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,187,325.87Zm-18,9.89a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,169,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,172.56,335.76Zm3.6,0A1.2,1.2,0,1,0,175,337,1.2,1.2,0,0,0,176.16,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,179.76,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,183.36,335.76Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,187,335.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.08,342.83h-4.2a1,1,0,0,1,0-2.07h4.2a1,1,0,1,1,0,2.07Zm1,3.76a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,346.59Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,351.39Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,356.19Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,361Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,365.79Zm0,4.79a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,370.58Zm0,4.8a1,1,0,0,0-1-1h-4.2a1,1,0,0,0,0,2.07h4.2A1,1,0,0,0,136.12,375.38Zm15.7-33.58a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,341.8Zm0,4.79a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,346.59Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,351.39Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,356.19Zm0,4.8a1,1,0,0,0-1-1h-11a1,1,0,1,0,0,2.07h11A1,1,0,0,0,151.82,361Zm13.19,4.8a1,1,0,0,0-1-1H153a1,1,0,1,0,0,2.07h11A1,1,0,0,0,165,365.79Zm0,4.79a1,1,0,0,0-1-1H153a1,1,0,1,0,0,2.07h11A1,1,0,0,0,165,370.58Zm0,4.8a1,1,0,0,0-1-1H153a1,1,0,1,0,0,2.07h11A1,1,0,0,0,165,375.38Zm-8.34-33.58a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,156.67,341.8Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,160.27,341.8Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,163.87,341.8Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,167.47,341.8Zm3.59,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm-18,9.59a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,156.67,351.39Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,160.27,351.39Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,163.87,351.39Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,167.47,351.39Zm3.59,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,171.06,351.39Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,174.66,351.39Zm-5.7,13.8a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,169,365.19Zm3.6,0a1.2,1.2,0,0,0-2.4,0,1.2,1.2,0,1,0,2.4,0Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,176.16,365.19Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,179.76,365.19Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,183.36,365.19Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,187,365.19Zm-18,9.89a1.2,1.2,0,1,0-1.19,1.2A1.19,1.19,0,0,0,169,375.08Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,172.56,375.08Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,176.16,375.08Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,179.76,375.08Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,183.36,375.08Zm3.6,0a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,187,375.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Progress--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.39,
    y: 271.6,
    width: 101.44,
    height: 12.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.39,
    y: 271.6,
    width: 50.72,
    height: 12.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,266a2.29,2.29,0,0,1-1.25-.3,1.68,1.68,0,0,1-.69-.89,4,4,0,0,1-.22-1.43h.88a3.89,3.89,0,0,0,.11,1,1.24,1.24,0,0,0,.41.67,1.27,1.27,0,0,0,.8.23A1.13,1.13,0,0,0,114,265a1.57,1.57,0,0,0,.39-.84,7.35,7.35,0,0,0,.11-1.35,6,6,0,0,0-.13-1.42,1.3,1.3,0,0,0-.42-.76,1.17,1.17,0,0,0-.78-.24,1.27,1.27,0,0,0-.7.21,1.81,1.81,0,0,0-.56.6h-.73v-5h3.78l0,.83h-3l0,3.37a1.82,1.82,0,0,1,.58-.46,2,2,0,0,1,.91-.19,1.74,1.74,0,0,1,1.15.36,1.89,1.89,0,0,1,.63,1,5.72,5.72,0,0,1,.2,1.6,7.23,7.23,0,0,1-.12,1.4,2.91,2.91,0,0,1-.39,1,1.72,1.72,0,0,1-.7.64A2.21,2.21,0,0,1,113.1,266Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,266a2.32,2.32,0,0,1-1.37-.37,2,2,0,0,1-.72-1,4.56,4.56,0,0,1-.22-1.48v-4.22a4.53,4.53,0,0,1,.23-1.49,2,2,0,0,1,.73-1A2.29,2.29,0,0,1,119,256a2.34,2.34,0,0,1,1.37.36,2.06,2.06,0,0,1,.72,1,4.54,4.54,0,0,1,.22,1.49v4.22a4.83,4.83,0,0,1-.21,1.49,2,2,0,0,1-.72,1A2.28,2.28,0,0,1,119,266Zm0-.7a1.25,1.25,0,0,0,.87-.28,1.54,1.54,0,0,0,.43-.76,4.27,4.27,0,0,0,.13-1.06v-4.35a4.27,4.27,0,0,0-.13-1.06,1.46,1.46,0,0,0-.43-.75,1.48,1.48,0,0,0-1.73,0,1.46,1.46,0,0,0-.43.75,3.85,3.85,0,0,0-.13,1.06v4.35a3.85,3.85,0,0,0,.13,1.06,1.48,1.48,0,0,0,.44.76A1.19,1.19,0,0,0,119,265.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.09,261a1.26,1.26,0,0,1-1.14-.52,2.5,2.5,0,0,1-.33-1.35v-1.36a2.39,2.39,0,0,1,.33-1.34,1.25,1.25,0,0,1,1.14-.49,1.28,1.28,0,0,1,1.14.48,2.36,2.36,0,0,1,.33,1.33v1.41a2.4,2.4,0,0,1-.33,1.33A1.25,1.25,0,0,1,124.09,261Zm0-.68a.54.54,0,0,0,.41-.15.83.83,0,0,0,.2-.42,2.58,2.58,0,0,0,.06-.58v-1.43a2.08,2.08,0,0,0-.13-.81.55.55,0,0,0-.54-.31.53.53,0,0,0-.54.32,2.08,2.08,0,0,0-.13.81v1.42a2.61,2.61,0,0,0,.06.59.93.93,0,0,0,.2.41A.54.54,0,0,0,124.09,260.32Zm.52,5.52,3.08-9.8h.77l-3.06,9.8Zm4.35.07a1.23,1.23,0,0,1-1.13-.52,2.45,2.45,0,0,1-.33-1.35V262.7a2.41,2.41,0,0,1,.33-1.35,1.26,1.26,0,0,1,1.13-.49,1.28,1.28,0,0,1,1.14.48,2.24,2.24,0,0,1,.34,1.33v1.39a2.45,2.45,0,0,1-.33,1.35A1.28,1.28,0,0,1,129,265.91Zm0-.67a.54.54,0,0,0,.42-.16.76.76,0,0,0,.2-.41,2.58,2.58,0,0,0,.06-.58v-1.43a2.07,2.07,0,0,0-.14-.81.52.52,0,0,0-.54-.32.53.53,0,0,0-.54.32,2.29,2.29,0,0,0-.13.81v1.43a2.58,2.58,0,0,0,.06.58.84.84,0,0,0,.21.41A.49.49,0,0,0,129,265.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.71,
    y: 188.27,
    width: 46.89,
    height: 33.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.84,
    y: 156.13,
    width: 22.62,
    height: 16.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.38,
    y1: 187.75,
    x2: 345.38,
    y2: 171.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.38,
    y1: 238.24,
    x2: 345.38,
    y2: 222.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 245.97,
    r: 8.24,
    transform: "translate(-72.77 316.27) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "377.79 178.99 360.84 178.99 360.84 187.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "397.41 230.77 410.82 230.77 410.82 178.99 397.41 178.99",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "360.84 221.76 360.84 230.77 377.79 230.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.61,
    y: 172.9,
    width: 20.09,
    height: 12.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.61,
    y: 198.09,
    width: 20.09,
    height: 12.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.61,
    y: 223.28,
    width: 20.09,
    height: 12.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.04,
    y1: 185.79,
    x2: 388.04,
    y2: 198.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.04,
    y1: 210.69,
    x2: 388.04,
    y2: 222.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "241.93 193.69 241.93 180.5 308.25 180.5 308.25 230.04 241.93 230.04 241.93 208.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.24,
    cy: 157.73,
    r: 13.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.57,
    cy: 201.28,
    r: 7.95,
    transform: "translate(-71.3 236.83) rotate(-46.56)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.85,
    y1: 169.71,
    x2: 296.26,
    y2: 181.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.66,
    y1: 240.83,
    x2: 313.04,
    y2: 240.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.66,
    y1: 245.42,
    x2: 313.04,
    y2: 245.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.66,
    y1: 250.02,
    x2: 313.04,
    y2: 250.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.66,
    y1: 254.61,
    x2: 313.04,
    y2: 254.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.66,
    y1: 259.21,
    x2: 313.04,
    y2: 259.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.41,
    y1: 195.28,
    x2: 355.79,
    y2: 195.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.41,
    y1: 199.88,
    x2: 355.79,
    y2: 199.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.41,
    y1: 204.47,
    x2: 355.79,
    y2: 204.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.41,
    y1: 209.07,
    x2: 355.79,
    y2: 209.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.41,
    y1: 213.66,
    x2: 355.79,
    y2: 213.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.56,
    cy: 125.86,
    rx: 20.28,
    ry: 52.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.56,
    cy: 125.86,
    rx: 14.23,
    ry: 36.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.64,125.86c0,9.51-3,17.22-6.62,17.22s-6.62-7.71-6.62-17.22,3-17.22,6.62-17.22S109.64,116.35,109.64,125.86Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.44,
    y1: 140.31,
    x2: 131.82,
    y2: 140.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.44,
    y1: 144.91,
    x2: 131.82,
    y2: 144.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.44,
    y1: 149.5,
    x2: 131.82,
    y2: 149.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.44,
    y1: 154.09,
    x2: 131.82,
    y2: 154.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.44,
    y1: 158.69,
    x2: 131.82,
    y2: 158.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.39,
    y1: 128.4,
    x2: 109.93,
    y2: 128.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "155.56 162.86 155.56 222.64 126.75 222.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.55,
    y: 212.7,
    width: 24.19,
    height: 16.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.55,
    y: 188.17,
    width: 24.19,
    height: 16.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.75,
    y1: 196.13,
    x2: 155.25,
    y2: 196.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg12);
export default __webpack_public_path__ + "static/media/img12.d3db3c10886ea95ff254a2ea3d7dd143.svg";
export { ForwardRef as ReactComponent };